(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["oc-footer"] && !Shopify.designMode) return;
  try {
    
  // Auto-submit the localization form when the country/region selector changes —
  // Shopify's standard pattern for the storefront locale switcher.
  document.querySelectorAll('.oc-footer__locale-form--js').forEach((form) => {
    const select = form.querySelector('select[name="country_code"]');
    if (!select) return;
    select.addEventListener('change', () => form.submit());
  });

  // On mobile, the menu columns use <details> as accordions; on desktop they're always
  // expanded. The `open` attribute toggles per the spec ≥1024px = open, <1024px = collapsed.
  // Use a single matchMedia listener instead of per-element ResizeObserver.
  (function () {
    const accordions = document.querySelectorAll('[data-oc-acc]');
    if (!accordions.length) return;
    const mq = window.matchMedia('(min-width: 1024px)');
    const sync = () => {
      accordions.forEach((d) => {
        if (mq.matches) {
          d.open = true;
        } else if (!d.dataset.ocUserToggled) {
          d.open = false;
        }
      });
    };
    accordions.forEach((d) => {
      d.addEventListener('toggle', () => {
        if (!mq.matches) d.dataset.ocUserToggled = '1';
      });
    });
    if (mq.addEventListener) mq.addEventListener('change', sync); else mq.addListener(sync);
    sync();
  })();

  } catch(e) { console.error(e); }
})();
})();
